import {
  EXTRA_TALL, MEDIUM, TALL,
} from '@/constants/heightMappingTableValues';
const DEFAULT_THUMBNAILS_SIZES = (url = '') => ({
  large: {
    height: 104,
    width: 235,
    url,
  },
  medium: {
    height: 92,
    width: 238,
    url,
  },
  small: {
    height: 60,
    width: 238,
    url,
  },
});
const THUMBNAILS_SIZE = {
  [EXTRA_TALL]: 'large',
  [TALL]: 'medium',
  [MEDIUM]: 'small',
};
const DEFAULT_FIELD_THUMBNAILS = (url = '') => {
  return {
    full: {
      height: 50,
      width: 50,
      url,
    },
    large: {
      height: 50,
      width: 50,
      url,
    },
    small: {
      height: 36,
      width: 35,
      url: false,
    },
  };
};
export {
  DEFAULT_THUMBNAILS_SIZES, THUMBNAILS_SIZE, DEFAULT_FIELD_THUMBNAILS,
};
